<script setup lang="ts">
import { KsExpandItem } from "@aschehoug/kloss";

const article = inject(keys.currentArticle);

const episodes = computed(() =>
  article?.contentType === "podcast"
    ? article.episodes
    : article?.podcastEpisodes,
);
</script>

<template>
  <main id="main-content">
    <UiArticlesCoverWithImage v-if="article?.cover?.url" />
    <UiArticlesCoverWithoutImage v-else class="mb-8" />
    <Content width="article">
      <UiArticlesShareLinks />
      <UiArticlesBody class="mb-16 mt-8 min-h-4" />
      <ul v-if="episodes?.length" class="mb-16 mt-4 flex min-h-80 w-full flex-col gap-8 pb-16 sm:mt-0">
        <li
          v-for="episode in episodes"
          :key="episode.id"
          class="flex flex-col gap-2"
        >
          <div v-html="episode.embed" />
          <KsExpandItem
            v-if="episode.transcription"
            title="Transkribering"
            class="[--ks-secondary:theme(colors.green.60)]"
          >
            <template #content>
              <div v-html="episode.transcription" />
            </template>
          </KsExpandItem>
        </li>
      </ul>
      <template v-if="article?.contentType === 'article' && article.podcast">
        <h2 class="text-green-60">
          Podkast-episode
        </h2>
        <div class="mb-8 mt-4" v-html="article.podcast" />
      </template>
      <slot />
    </Content>
  </main>
</template>
